import { z } from 'zod';
/**
 * User identifiers are Clerk ids (`user_2abc…`), not UUIDs.
 *
 * Migration `20260325130000_clerk_uuid_to_text` turned `users.id` — and every
 * column referencing it — from `uuid` into `text` (cf. ADR-011). Validating a
 * user id with `z.string().uuid()` therefore rejects every real account and
 * fails the request with a 400. Legacy UUID ids still exist in seed data, so
 * this schema accepts both shapes and only guarantees a non-empty identifier.
 */
export const userIdSchema = z.string().min(1);
//# sourceMappingURL=user-id.js.map